var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { portkey } from '@portkey/accounts';
import { DIDWallet } from './wallet.js';
import { Services, Connect, } from '@portkey/services';
import { FetchRequest } from '@portkey/request';
import { DIDGraphQL } from '@portkey/graphql';
import { DIDConfig } from './config.js';
export class DID {
    constructor() {
        this.accountProvider = new portkey.AccountProvider();
        this.config = new DIDConfig();
        this.fetchRequest = new FetchRequest(this.config.requestConfig);
        this.connectRequest = new FetchRequest(this.config.connectRequestConfig);
        this.didGraphQL = new DIDGraphQL({ config: this.config });
        this.connectServices = new Connect(this.connectRequest);
        this.services = new Services(this.fetchRequest, this.didGraphQL, this.config.referralConfig);
        this.didWallet = new DIDWallet({
            accountProvider: this.accountProvider,
            service: this.services.communityRecovery,
            storage: this.config.storageMethod,
            connectService: this.connectServices,
        });
    }
    signTransaction(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.signTransaction(tx);
        });
    }
    getCAHolderInfo(originChainId) {
        return this.didWallet.getCAHolderInfo(originChainId);
    }
    getLoginStatus(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.getLoginStatus(params);
        });
    }
    getRegisterStatus(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.getRegisterStatus(params);
        });
    }
    getVerifierServers(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.getVerifierServers(chainId);
        });
    }
    create() {
        this.didWallet.create();
        return this;
    }
    save(password, keyName) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.save(password, keyName);
        });
    }
    load(password, keyName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.didWallet.load(password, keyName);
            return this;
        });
    }
    login(type, params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.login(type, params);
        });
    }
    logout(params, sendOption) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.logout(params, sendOption);
        });
    }
    register(params) {
        return this.didWallet.register(params);
    }
    getHolderInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.getHolderInfo(params);
        });
    }
    sign(data) {
        return this.didWallet.sign(data);
    }
    encrypt(password, options) {
        return this.didWallet.encrypt(password, options);
    }
    aesEncrypt(password) {
        return this.didWallet.aesEncrypt(password);
    }
    setConfig(options) {
        this.config.setConfig(options);
    }
    reset() {
        this.didWallet.reset();
    }
    checkManagerIsExist(params) {
        return this.didWallet.checkManagerIsExist(params);
    }
    checkStorageAesStrIsExist(keyName) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.didWallet.checkStorageAesStrIsExist(keyName);
        });
    }
}
